import { QueryParamsEntities } from "./MainApp";
import { Pagination } from "./Pagination";

export class RequestTabsList {
  q = "";
  startDate = "";
  endDate = "";
  shipmentType = "";
  courierId = 0;
  status = "CRROTW";

  constructor(fields?: Partial<RequestTabsList>) {
    console.log("request: ", fields);
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class TabsData {
  seller = 0;
  courier = 0;
  shipment = 0;
  quantity = 0;
  status = "";
  statusLabel = "";

  constructor(fields?: Partial<TabsData>) {
    Object.assign(this, fields);
  }

}

export class TabsList {
  data: TabsData[] = [new TabsData()];

  constructor(fields?: Partial<TabsList>) {
    Object.assign(this, fields);
  }
}
export class RequestListSummary {
  q = "";
  startDate = "";
  endDate = "";
  status = "CRROTW";
  shipmentType = "";
  sortBy = "";
  orderBy = "";
  page = 1;
  limit = 20;

  constructor(fields?: Partial<RequestListSummary>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class ListSummaryItem {
  courierId = 0;
  courierName = "";
  courierPhone = "";

  senderName = "";
  senderPhone = "";
  senderAddress = "";

  shipmentType = "";
  shipmentId = "";

  totalShipment = 0;
  totalQuantity = 0;
  totalWeight = 0;

  expiredAt = "";
  status = "";
  statusAt = "";

  proofs: string[] = [];
  isAbleToBooking = false;

  lat = 0;
  lon = 0;

  taskId = 0;
  incrementId = 0;

  constructor(fields?: Partial<ListSummaryItem>) {
    Object.assign(this, fields);
  }
}

export class SummaryDataList {
  data: ListSummaryItem[];
  page: number;
  limit: number;
  totalRecords: number;
  isLoading: boolean;

  constructor(fields: Partial<SummaryDataList> = {}) {
    const {
      data = [],
      page = 1,
      limit = 20,
      totalRecords = 0,
      isLoading = false,
    } = fields;

    this.data = data;
    this.page = page;
    this.limit = limit;
    this.totalRecords = totalRecords;
    this.isLoading = isLoading;
  }
}

export class PickupDashboardMonitoringDetailSummary {
  data: ListSummaryItem[] = [];
  pagination: Pagination = new Pagination(1, 10, 0);
  
  constructor(fields?: PickupDashboardMonitoringDetailSummary) {
    Object.assign(this, fields);
  }
}
